export const compose = (...components) => {
  return ({ children }) => {
    const renderProps = (child, [Current, props = {}]) => <Current {...props}>{child}</Current>;
    return components.reduceRight(renderProps, children);
  };
};
